import React,{useState,useEffect} from 'react'
import { DataGrid,GridActionsCellItem } from '@mui/x-data-grid';
import campaignService from '../../services/campaign.service'
import {useNavigate,Link,useLocation} from 'react-router-dom'
import PreviewIcon from '@mui/icons-material/Preview';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import FormatListNumberedRtlIcon from '@mui/icons-material/FormatListNumberedRtl';
import DangerousIcon from '@mui/icons-material/Dangerous';
function CampaignTable() {
    const [campaigns,setCampaigns] = useState([])
    const [rowCount,setRowCount] = useState(10)
    const [paginationModel,setPaginationModel] = useState({
        page:0,
        pageSize:10,
     })
     const navigate = useNavigate()
   
      const columns = [
        {field:"id", headerName:'#',width:'50'},
        {field:"clinicName", headerName:'Clinic Name',width:'200'},
       
      {
        field:"type",headerName:"Type",width:'50',
        renderCell :({value}) =>{
          if(value === "EMAIL"){
            return <EmailIcon/>
          }else{
            return <SmsIcon/>
          }
        }
      },
      
      {field:"category",headerName:'Category',width:'150'},
        {field:"name",headerName:'Name',width:'200'},
        {field:"title",headerName:'Title',width:'300'},
        {field:"actions",headerName:'Actions', type: "actions", width:'200',
        getActions: (allValues) => {
         
          return [
            <GridActionsCellItem
              icon={<PreviewIcon />}
              label="Preview"
             
              onClick={()=>handlePreviewClick(allValues.id,allValues.row)}
            />,
            <GridActionsCellItem
              icon={<LeaderboardIcon />}
              label="Statistics"
              className="textPrimary"
              onClick={()=>handleStatisticsClick(allValues.id,allValues.row)}
           
            />,
            <GridActionsCellItem
              icon={<FormatListNumberedRtlIcon />}
              label="Statistics"
              className="textPrimary"
              onClick={()=>handleQueClick(allValues.id,allValues.row)}
           
            />,
            <GridActionsCellItem
              icon={<DangerousIcon />}
              label="Statistics"
              className="textPrimary"
              onClick={()=>handleStopClick(allValues.id,allValues.row)}
           
            />,
          ];
          }
        }
      ]

      useEffect(()=>{
        getCampaign(paginationModel.page,paginationModel.pageSize)

      },[paginationModel.page,paginationModel.pageSize])

      const getCampaign = (pageNo,pageSize)=>{
        campaignService.getCampaign(pageNo,pageSize)
        .then(res=>{
            setCampaigns(res.data.content)
            setRowCount(res.data.totalElements)
        })
        .catch(err=>{
            console.log(err)
        })
      }
      const handlePreviewClick = (id,info)=>{
        navigate('/campaign/preview/'+id,{ state: { info: info } })
      }
     const handleStatisticsClick = (id,info)=>{
         navigate('/campaign/stats/'+id,{ state: { info: info } })
      }
      const handleQueClick = (id,info)=>{
        navigate('/campaign/queue/'+id,{ state: { info: info } })
     }
     const handleStopClick = (id,info)=>{
      navigate('/campaign/stop/'+id,{ state: { info: info } })
   }

  return (
   <>
    <div style={{ width: '100%' }}>
    <DataGrid
        rows={campaigns}
        rowCount={rowCount}
        columns={columns}
        pagination
        paginationModel={paginationModel}
        pageSizeOptions={[5, 10]}
        paginationMode='server'
        onPaginationModelChange={setPaginationModel}


       />
    </div>
   
   </>
  )
}

export default CampaignTable